import { render, staticRenderFns } from "./InvoicesDashboard.vue?vue&type=template&id=991b88b6&lang=pug&"
import script from "./InvoicesDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoicesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports